import React, { FC, useState, Fragment, Dispatch, SetStateAction } from 'react';

import { PageTitle } from '../common-styles/common-styles';
import * as CSS from './player-styles';
import { UpdateButton } from './update-button';

type PlayerEntryProps = {
  playerIndex: number;
  playerId?: number;
  name?: string;
  nickName?: string;
  virtual?: boolean;
  admin?: boolean;
  onTour?: boolean;
  resetDataEntry: Dispatch<SetStateAction<boolean>>;
};
export const PlayerEntry: FC<PlayerEntryProps> = ({ playerIndex, resetDataEntry, name = '', nickName = '', virtual = false, admin = false, onTour = true }) => {
  const [updateStatus, setUpdateStatus] = useState({ success: false, error: false });
  const [playerName, setPlayerName] = useState<string>(name);
  const [playerNickname, setPlayerNickname] = useState<string>(nickName);
  const [dataValid, setDataValid] = useState<boolean>(Boolean(name) && Boolean(nickName));
  const [playerVirtual, setPlayerVirtual] = useState<boolean>(virtual);
  const [playerAdmin, setPlayerAdmin] = useState<boolean>(admin);
  const [playerOnTour, setPlayerOnTour] = useState<boolean>(onTour);

  const validatePlayer = () => {
    if (Boolean(playerName) && Boolean(playerNickname)) {
      return setDataValid(true);
    } else {
      return setDataValid(false);
    }
  };
  return (
    <Fragment>
      <PageTitle>
        <h2>Player Details</h2>
      </PageTitle>
      {updateStatus.error && <CSS.ErrorMessage>Update failed!!!!</CSS.ErrorMessage>}
      <form onSubmit={(event) => event.preventDefault()}>
        <CSS.NameWrapper>
          <div>Name</div>
          <input
            type="text"
            name="name"
            id="player-name"
            data-testid="player-name"
            value={playerName}
            onChange={(e) => {
              setPlayerName(e.target.value);
              validatePlayer();
            }}
          />
        </CSS.NameWrapper>
        <CSS.NameWrapper>
          <div>Nickname</div>
          <input
            type="text"
            name="nickName"
            id="nickName"
            data-testid="nickName"
            value={playerNickname}
            onChange={(e) => {
              setPlayerNickname(e.target.value);
              validatePlayer();
            }}
          />
        </CSS.NameWrapper>
        <CSS.InputWrapper>
          <div>On Tour</div>
          <CSS.FlexRow>
            <CSS.FlexRow>
              <label htmlFor="on-tour-true">true</label>
              <input type="radio" name="onTour" id="on-tour-true" value="true" data-testid="on-tour-true" checked={playerOnTour === true} onChange={() => setPlayerOnTour(true)} />
            </CSS.FlexRow>
            <CSS.FlexRow>
              <label htmlFor="on-tour-false">false</label>
              <input
                type="radio"
                name="onTour"
                id="on-tour-false"
                value="false"
                data-testid="on-tour-false"
                checked={playerOnTour === false}
                onChange={() => {
                  setPlayerOnTour(false);
                }}
              />
            </CSS.FlexRow>
          </CSS.FlexRow>
        </CSS.InputWrapper>
        <CSS.InputWrapper>
          <div>Admin</div>
          <CSS.FlexRow>
            <CSS.FlexRow>
              <label htmlFor="admin-true">true</label>
              <input type="radio" name="adminS" id="admin-true" value="true" data-testid="admin-true" checked={playerAdmin === true} onChange={() => setPlayerAdmin(true)} />
            </CSS.FlexRow>
            <CSS.FlexRow>
              <label htmlFor="admin-false">false</label>
              <input
                type="radio"
                name="adminS"
                id="admin-false"
                value="false"
                data-testid="admin-false"
                checked={playerAdmin === false}
                onChange={() => {
                  setPlayerAdmin(false);
                }}
              />
            </CSS.FlexRow>
          </CSS.FlexRow>
        </CSS.InputWrapper>
        <CSS.InputWrapper>
          <div>Virtual</div>
          <CSS.FlexRow>
            <CSS.FlexRow>
              <label htmlFor="singles">true</label>
              <input type="radio" name="virtual" value="true" id="virtual" data-testid="virtual-true" checked={playerVirtual === true} onChange={() => setPlayerVirtual(true)} />
            </CSS.FlexRow>
            <CSS.FlexRow>
              <label htmlFor="pairs">false</label>
              <input
                type="radio"
                name="virtual"
                value="false"
                id="virtual"
                data-testid="virtual-false"
                checked={playerVirtual === false}
                onChange={() => setPlayerVirtual(false)}
              />
            </CSS.FlexRow>
          </CSS.FlexRow>
        </CSS.InputWrapper>
      </form>
      <CSS.ButtonWrapper>
        <UpdateButton
          player={{
            name: playerName,
            id: playerIndex + 1,
            nickName: playerNickname,
            admin: playerAdmin,
            virtual: playerVirtual,
            onTour: playerOnTour,
          }}
          playerIndex={playerIndex}
          setUpdateStatus={setUpdateStatus}
          setShowUpdate={resetDataEntry}
          disabled={!dataValid}
        />
        <CSS.Button
          onClick={() => {
            resetDataEntry(false);
          }}
        >
          Cancel
        </CSS.Button>
      </CSS.ButtonWrapper>
    </Fragment>
  );
};
